export default "__VITE_ASSET__lomy$Esc__"